import { default as MuiText, typographyClasses } from '@mui/material/Typography';
export { typographyClasses };
export var Text = MuiText;
